export default "__VITE_ASSET__C7qc1uDs__"